import { render } from "./NossaHistoria.vue?vue&type=template&id=42d8e51c&scoped=true&lang=pug"
import script from "./NossaHistoria.vue?vue&type=script&lang=js"
export * from "./NossaHistoria.vue?vue&type=script&lang=js"

import "./NossaHistoria.vue?vue&type=style&index=0&id=42d8e51c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d8e51c"]])

export default __exports__